import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';

// Configura i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    lng: 'en', // Idioma por defecto
    fallbackLng: 'en', // Idioma alternativo en caso de que el seleccionado no esté disponible
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;